import { IReportingPeriodApplicantDocumentService } from "../../service/document/ReportingPeriodApplicantDocumentService";

export default class UpdateDocumentInteractor {
  private reportingPeriodApplicantDocumentService: IReportingPeriodApplicantDocumentService;

  constructor(reportingPeriodApplicantDocumentService) {
    this.reportingPeriodApplicantDocumentService = reportingPeriodApplicantDocumentService;
  }

  async execute(documentId: number, document: any) {
    await this.reportingPeriodApplicantDocumentService.updateDocument(
      documentId,
      document
    );
  }
}
